import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { IntraOne_ModuleContextService } from './IntraOne.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class IntraOne_intraone_library_home_ComponentContextService {
  private readonly moduleContext: IntraOne_ModuleContextService;

  constructor(moduleContext: IntraOne_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'intraone_library_home',
      type: ComponentType.form
    }
  }
}